import flatpickr from "flatpickr";
import { French } from "flatpickr/dist/l10n/fr.js";
import {Calendar} from '@fullcalendar/core';
import interactionPlugin from '@fullcalendar/interaction';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';

let width = document.body.clientWidth;
let height = document.body.clientHeight;
let inputCalendars = [];
let inputHours = [];
let overlapping = false;
var fullCalendar;
let currentLanguage = document.querySelector('html').getAttribute('lang');

function createSelectEvent(start, end, filled) {
    let removeEvents = fullCalendar.getEvents();

    removeEvents.forEach(event => {
        if (!event.title) {
            event.remove();
        }
    });

    if (filled === undefined || filled === false) {
        let startBooking = new Date(start)
        let endBooking = new Date(end)
        let yearStart = startBooking.getFullYear().toString();
        let monthStart = (startBooking.getMonth() + 1).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let dayStart = (startBooking.getDate()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let hourStart = (startBooking.getHours()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let minStart = (startBooking.getMinutes()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });

        let yearEnd = endBooking.getFullYear().toString();
        let monthEnd = (endBooking.getMonth() + 1).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let dayEnd = (endBooking.getDate()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let hourEnd = (endBooking.getHours()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let minEnd = (endBooking.getMinutes()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        document.querySelector('input[name="eventStartDate"]').value = dayStart + "-" + monthStart + "-" + yearStart;
        if (inputCalendars["eventStartDate"]) {
            inputCalendars["eventStartDate"].setDate(dayStart + "-" + monthStart + "-" + yearStart);
        }
        if (document.querySelectorAll('[name="eventStartTime"]').length > 0) {
            document.querySelector('[name="eventStartTime"]').value = hourStart + ":" + minStart;
        }
        // document.querySelector('select[name="eventStartTime"]').value = (parseInt(hourStart) + 2) + ":" + minStart;
        // inputHours["eventStartTime"].setDate(hourStart + ":" + minStart);
        document.querySelector('input[name="eventEndDate"]').value = dayEnd + "-" + monthEnd + "-" + yearEnd;
        if (inputCalendars["eventEndDate"]) {
            inputCalendars["eventEndDate"].setDate(dayEnd + "-" + monthEnd + "-" + yearEnd);
        }
        if (document.querySelectorAll('[name="eventEndTime"]').length > 0) {
            document.querySelector('[name="eventEndTime"]').value = hourEnd + ":" + minEnd;
        }
        // document.querySelector('select[name="eventEndTime"]').value = (parseInt(hourEnd) - 2) + ":" + minEnd;
        // inputHours["eventEndTime"].setDate(hourEnd + ":" + minEnd);

        document.querySelector('input[name="rentStartDate"]').value = dayStart + "-" + monthStart + "-" + yearStart;
        if (inputCalendars["rentStartDate"]) {
            inputCalendars["rentStartDate"].setDate(dayStart + "-" + monthStart + "-" + yearStart);
        }
        if (document.querySelectorAll('[name="rentStartTime"]').length > 0) {
            document.querySelector('[name="rentStartTime"]').value = hourStart + ":" + minStart;
        }
        // inputHours["rentStartTime"].setDate(hourStart + ":" + minStart);
        document.querySelector('input[name="rentEndDate"]').value = dayEnd + "-" + monthEnd + "-" + yearEnd;
        if (inputCalendars["rentEndDate"]) {
            inputCalendars["rentEndDate"].setDate(dayEnd + "-" + monthEnd + "-" + yearEnd);
        }
        if (document.querySelectorAll('[name="rentEndTime"]').length > 0) {
            document.querySelector('[name="rentEndTime"]').value = hourEnd + ":" + minEnd;
        }
        // inputHours["rentEndTime"].setDate(hourEnd + ":" + minEnd);

        inputCalendars["rentEndDate"].set('minDate', dayStart + "-" + monthStart + "-" + yearStart);
        inputCalendars["eventEndDate"].set('minDate', dayStart + "-" + monthStart + "-" + yearStart);

        // let validatorDates = document.querySelectorAll('.flatpickr-input.valid-date');
        // // let alertDone = false;
        // for (const validatorDate of validatorDates) {
        //     let dateValidator = validatorDate.value.split('-');
        //     let dateEnter = new Date(dateValidator[2] + "-" + dateValidator[1] + "-" + dateValidator[0]);
        //     let numberDaysToRemove = document.querySelectorAll('#formContact').length > 0 && document.querySelector('#formContact').dataset.numberdays ? parseInt(document.querySelector('#formContact').dataset.numberdays) : 30;
        //     dateEnter.setDate(dateEnter.getDate() - numberDaysToRemove);
        //     let nowDate = new Date();
        //     if (nowDate > dateEnter) {
        //         if (validatorDate.dataset.linkerror) {
        //             document.querySelector(validatorDate.dataset.linkerror).classList.remove('d-none');
        //         }
        //         if (!alertDone && validatorDate.dataset.linkerror) {
        //             if (validatorDate.dataset.linkerror) {
        //                 alert(document.querySelector(validatorDate.dataset.linkerror).textContent);
        //             }
        //             alertDone = true;
        //         }
        //     } else {
        //         if (validatorDate.dataset.linkerror) {
        //             document.querySelector(validatorDate.dataset.linkerror).classList.add('d-none');
        //         }
        //     }
        // }
        window.scrollTo(0, document.querySelector('#formContact').getBoundingClientRect().top + window.scrollY);
    }
    var eventData;
    eventData = {
        start: start,
        end: end,
        backgroundColor: "#323232",
    };

    // if (!isOverlapping(eventData)) {
    //     overlapping = false;
    //     fullCalendar.addEvent(eventData);
    // } else {
    //     overlapping = true;
    //     alert("this date overlap another one");
    // }

    fullCalendar.gotoDate(eventData.start);
    fullCalendar.addEvent(eventData);
}





document.addEventListener('DOMContentLoaded', function () {
    /*
    * HASH
    */
    if (document.getElementById('uniqueHash')) {
        function generateHash() {
            var hash = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            return hash;
        }

        var uniqueHash = generateHash();
        document.getElementById('uniqueHash').value = uniqueHash;
        localStorage.setItem('uniqueHash', uniqueHash);
    }

    /*
    * Datepicker
    * */

    if (document.querySelectorAll('.input-date').length > 0) {
        let calendars = document.querySelectorAll('.input-date');
        for (const calendar of calendars) {
            let minDays = document.querySelector('.js-form-booking') && parseInt(document.querySelector('.js-form-booking').dataset.mindays) >= 0 ? parseInt(document.querySelector('.js-form-booking').dataset.mindays) - 1 : 2;
            let curr = new Date;
            let minDate = curr.setDate(curr.getDate() + (parseInt(minDays) + 1));
            minDate = new Date(minDate).getDate() + "-" + (new Date(minDate).getMonth() + 1) + "-" + new Date(minDate).getFullYear();
            inputCalendars[calendar.getAttribute('name')] = flatpickr(calendar, {
                allowInput: true,
                altInput: true,
                altFormat: "d-m-Y",
                disableMobile: "true",
                dateFormat: calendar.dataset.format ? calendar.dataset.format : "d-m-Y",
                "locale": document.querySelector('html').getAttribute('lang'),
                minDate: calendar.classList.contains('min-booking') ? minDate : false,
            });
        }
    }

    if (document.querySelectorAll('.input-hour').length > 0) {
        let calendars = document.querySelectorAll('.input-hour');
        for (const calendar of calendars) {
            inputHours[calendar.getAttribute('name')] = flatpickr(calendar, {
                enableTime: true,
                noCalendar: true,
                dateFormat: "H:i",
                disableMobile: "true",
                minuteIncrement: 30,
                allowInput: false,
                "locale": document.querySelector('html').getAttribute('lang'),
            });
        }
    }

    /*
    * Form Validation reservation
    * */

    if (document.querySelectorAll('.valid-date').length > 0) {
        let validatorDates = document.querySelectorAll('.valid-date');
        for (const validatorDate of validatorDates) {
            validatorDate.addEventListener('change', function (e) {
                let dateValidator = validatorDate.value.split('-')
                // let dateEnter = new Date(dateValidator[2] + "-" + dateValidator[1] + "-" + dateValidator[0]);
                // dateEnter.setMonth(dateEnter.getMonth() - 2);
                let dateEnter = new Date(dateValidator[2] + "-" + dateValidator[1] + "-" + dateValidator[0]);
                let numberDaysToRemove = document.querySelectorAll('#formContact').length > 0 && document.querySelector('#formContact').dataset.numberdays ? parseInt(document.querySelector('#formContact').dataset.numberdays) : 30;
                dateEnter.setDate(dateEnter.getDate() - numberDaysToRemove);
                let nowDate = new Date();
                if (nowDate > dateEnter) {
                    if (validatorDate.dataset.linkerror) {
                        document.querySelector(validatorDate.dataset.linkerror).classList.remove('d-none');
                    }
                } else {
                    if (validatorDate.dataset.linkerror) {
                        document.querySelector(validatorDate.dataset.linkerror).classList.add('d-none');
                    }
                }
            });
        }
    }

    if (document.querySelectorAll('.valid-date-one').length > 0) {
        let validatorDates = document.querySelectorAll('.valid-date-one');
        for (const validatorDate of validatorDates) {
            validatorDate.addEventListener('change', function (e) {
                let dateValidator = validatorDate.value.split('-')
                let dateEnter = new Date(dateValidator[2] + "-" + dateValidator[1] + "-" + dateValidator[0]);
                dateEnter.setMonth(dateEnter.getMonth() - 1);
                let nowDate = new Date();
                if (nowDate > dateEnter) {
                    if (validatorDate.dataset.linkerror) {
                        document.querySelector(validatorDate.dataset.linkerror).classList.remove('d-none');
                    }
                } else {
                    if (validatorDate.dataset.linkerror) {
                        document.querySelector(validatorDate.dataset.linkerror).classList.add('d-none');
                    }
                }
            });
        }
    }

    if (document.querySelectorAll('select[name="entity"]').length > 0 && document.querySelectorAll('#formMateriel').length === 0) {
        let entitySelects = document.querySelectorAll('select[name="entity"]');
        let beverageCheckbox = document.querySelector('input[name="beverageConcession"]');
        for (const entitySelect of entitySelects) {
            entitySelect.addEventListener('change', function (e) {
                if (entitySelect.value.includes("particulier") || entitySelect.value.includes("societe")) {
                    beverageCheckbox.setAttribute("disabled", "disabled");
                    beverageCheckbox.removeAttribute("checked");
                    beverageCheckbox.checked = false;
                } else {
                    beverageCheckbox.removeAttribute("disabled");
                }
            });
        }
    }

    if (document.querySelectorAll('#formMateriel').length > 0) {
        let entitySelects = document.querySelectorAll('select[name="entity"]');
        let isAssociations = document.querySelectorAll('.js-is-association');
        for (const entitySelect of entitySelects) {
            entitySelect.addEventListener('change', function (e) {
                if (entitySelect.value.includes("particulier")) {
                    for (const isAssociation of isAssociations) {
                        isAssociation.classList.add("d-none");
                    }
                } else {
                    for (const isAssociation of isAssociations) {
                        isAssociation.classList.remove("d-none");
                    }
                }
            });
        }
    }

    if (document.querySelectorAll('input[name="nbPeopleVertical"]').length > 0) {
        let nbPeopleVertical = document.querySelector('input[name="nbPeopleVertical"]');
        let nbPeopleSeated = document.querySelector('input[name="nbPeopleSeated"]');
        let nbPeopleTable = document.querySelector('input[name="nbPeopleTable"]');

        let functionVerticalPeople = function (current, target1, target2) {
            if (current.value && parseInt(current.value) > 0) {
                target1.value = "";
                target1.setAttribute("disabled", "disabled");
                target1.removeAttribute("required");
                target2.value = "";
                target2.setAttribute("disabled", "disabled");
                target2.removeAttribute("required");
            } else {
                target1.removeAttribute("disabled");
                target1.setAttribute("required", "required");
                target2.removeAttribute("disabled");
                target2.setAttribute("required", "required");
            }
        }

        nbPeopleVertical.addEventListener('keyup', function (event) {
            functionVerticalPeople(nbPeopleVertical, nbPeopleSeated, nbPeopleTable)
        });
        nbPeopleVertical.addEventListener('change', function (event) {
            functionVerticalPeople(nbPeopleVertical, nbPeopleSeated, nbPeopleTable)
        });

        nbPeopleSeated.addEventListener('keyup', function (event) {
            functionVerticalPeople(nbPeopleSeated, nbPeopleVertical, nbPeopleTable)
        });
        nbPeopleSeated.addEventListener('change', function (event) {
            functionVerticalPeople(nbPeopleSeated, nbPeopleVertical, nbPeopleTable)
        });

        nbPeopleTable.addEventListener('keyup', function (event) {
            functionVerticalPeople(nbPeopleTable, nbPeopleVertical, nbPeopleSeated)
        });
        nbPeopleTable.addEventListener('change', function (event) {
            functionVerticalPeople(nbPeopleTable, nbPeopleVertical, nbPeopleSeated)
        });
    }

    /* Full calendar */

    if (document.querySelectorAll('#fullCalendar').length > 0) {
        let calendarEl = document.getElementById('fullCalendar');
        let curr = new Date;
        let minDays = document.querySelector('.js-form-booking') && parseInt(document.querySelector('.js-form-booking').dataset.mindays) >= 0 ? document.querySelector('.js-form-booking').dataset.mindays : 2;
        let startSelectionDate = curr.setDate(curr.getDate() + parseInt(minDays));

        let yearFirstday = curr.getFullYear().toString();
        let yearLastday = (curr.getFullYear() + 2).toString();

        let dateFirstday = yearFirstday + "-01-01";
        let dateLastday = yearLastday + "-12-31";

        let nowYear = curr.getFullYear().toString();
        let nowMonth = (curr.getMonth() + 1).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let nowDay = (curr.getDate()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        // let minDays = document.querySelector('.js-form-booking') && parseInt(document.querySelector('.js-form-booking').dataset.mindays) >= 0 ? document.querySelector('.js-form-booking').dataset.mindays : 2;
        let nowDate = nowYear + "-" + nowMonth + "-" + nowDay;

        // let startSelectionDate = new Date(curr.setDate(curr.getDate() + parseInt(minDays)));

        // startSelectionDate = new Date(startSelectionDate).getFullYear() + "-" + (parseInt(new Date(startSelectionDate).getMonth() + 1) > 9 ? "" : "0") + (new Date(startSelectionDate).getMonth() + 1) + "-" + new Date(startSelectionDate).getDate();

        startSelectionDate = new Date(startSelectionDate);

        let yearMinDateSelect = startSelectionDate.getFullYear().toString();
        let monthMinDateSelect = (startSelectionDate.getMonth() + 1).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });
        let dayMinDateSelect = (startSelectionDate.getDate()).toLocaleString('en-US', {
            minimumIntegerDigits: 2,
            useGrouping: false
        });

        startSelectionDate = yearMinDateSelect + "-" + monthMinDateSelect + "-" + dayMinDateSelect;

        let idHall = calendarEl.dataset.idhall;
        fullCalendar = new Calendar(calendarEl, {
            plugins: [interactionPlugin, dayGridPlugin, timeGridPlugin],
            initialDate: startSelectionDate ? startSelectionDate : nowDate,
            headerToolbar: {
                left: 'today',
                center: 'prev title next',
                right: 'timeGridWeek,dayGridMonth'
            },
            selectable: true,
            selectConstraint: { // validRange
                start: startSelectionDate,
                end: "3000-12-31"
            },
            dayCellDidMount: (cell) => {
                let minDate = new Date(startSelectionDate);
                minDate.setHours(0, 0, 0, 0);
                let cellDate = cell.date;
                cellDate.setHours(0, 0, 0, 0);
                if (minDate.getTime() > cellDate.getTime()) {
                    cell.el.classList.add('past');
                }
            },
            selectOverlap: false,
            eventDurationEditable: false,
            eventStartEditable: false,
            navLinks: true,
            editable: true,
            dayMaxEvents: true, // allow "more" link when too many events
            minTime: '01:00:00',
            maxTime: '24:00:00',
            allDaySlot: false,
            locale: 'fr',
            initialView: width < 767 ? 'agendaTwoDay':'timeGridWeek',
            buttonText: {
                month: 'Mois',
                week: 'Semaine',
                today: "Aujourd'hui",
            },
            firstDay: 1,
            events: {
                url: `/${currentLanguage}/api-rentable?rentable=${idHall}&start=${dateFirstday}&end=${dateLastday}`,
                method: 'POST',
                failure: function () {
                    console.log('there was an error while fetching events!');
                }
            },
            views: {
                agendaTwoDay: {
                    type: 'timeGridWeek',
                    duration: {
                        days: 2
                    },
                    buttonText: '2 day agenda'
                }
            },
            select: function (date) {
                createSelectEvent(date.start, date.end);
            },
            eventClick: function (info) {
                if (!info.event.title) {
                    info.event.remove();
                    document.querySelector('input[name="eventStartDate"]').value = "";
                    if (inputCalendars["eventStartDate"]) {
                        inputCalendars["eventStartDate"].setDate("");   
                    }
                    document.querySelector('input[name="eventEndDate"]').value = "";
                    if (inputCalendars["eventEndDate"]) {
                        inputCalendars["eventEndDate"].setDate("");
                    }
                    document.querySelector('select[name="eventStartTime"]').value = "";
                    document.querySelector('select[name="eventEndTime"]').value = "";
                    document.querySelector('input[name="rentStartDate"]').value = "";
                    if (inputCalendars["rentStartDate"]) {
                        inputCalendars["rentStartDate"].setDate("");
                    }
                    document.querySelector('input[name="rentEndDate"]').value = "";
                    if (inputCalendars["rentEndDate"]) {
                        inputCalendars["rentEndDate"].setDate("");
                    }
                    document.querySelector('select[name="rentStartTime"]').value = "";
                    document.querySelector('select[name="rentEndTime"]').value = "";
                    document.querySelector("#alert-info-date-rentStartDate").classList.add('d-none');
                }
            }
        });

        fullCalendar.render();

        [document.querySelector('input[name="eventStartDate"]'), document.querySelector('[name="eventStartTime"]'), document.querySelector('input[name="eventEndDate"]'), document.querySelector('[name="eventEndTime"]'), document.querySelector('input[name="rentStartDate"]'), document.querySelector('[name="rentStartTime"]'), document.querySelector('input[name="rentEndDate"]'), document.querySelector('[name="rentEndTime"]')].forEach(item => {
            item.addEventListener("change", event => {
                // if (document.querySelector('input[name="rentStartDate"]').value && document.querySelector('input[name="rentEndDate"]').value && document.querySelector('select[name="rentStartTime"]').value && document.querySelector('select[name="rentEndTime"]').value) {
                    if (item.name === 'eventStartDate' || item.name === 'rentStartDate') {
                        let minDateToChange = inputCalendars[item.name].selectedDates[0];
                        inputCalendars["eventStartDate"].setDate(minDateToChange);
                        inputCalendars["rentStartDate"].setDate(minDateToChange);

                        if (inputCalendars["eventEndDate"].selectedDates[0]) {
                            inputCalendars["eventEndDate"].set('minDate', minDateToChange);
                        } else {
                            inputCalendars["eventEndDate"].setDate(minDateToChange);
                            inputCalendars["eventEndDate"].set('minDate', minDateToChange);
                            document.querySelector('select[name="eventStartTime"]').value = "00:00";
                            document.querySelector('select[name="eventEndTime"]').value = "23:00";
                        }

                        if (inputCalendars["rentEndDate"].selectedDates[0]) {
                            inputCalendars["rentEndDate"].set('minDate', minDateToChange);   
                        } else {
                            inputCalendars["rentEndDate"].setDate(minDateToChange);
                            inputCalendars["rentEndDate"].set('minDate', minDateToChange);
                            document.querySelector('select[name="rentStartTime"]').value = "00:00";
                            document.querySelector('select[name="rentEndTime"]').value = "23:00";
                        }
                    }

                    if (item.name === 'eventEndDate' || item.name === 'rentEndDate') {
                        let dateToChange = inputCalendars[item.name].selectedDates[0];
                        
                        if (item.name === 'eventEndDate') {
                            inputCalendars["rentEndDate"].setDate(dateToChange);
                        } else if (item.name === 'rentEndDate') {
                            inputCalendars["eventEndDate"].setDate(dateToChange);
                        }
                    }

                    let startBooking = document.querySelector('input[name="rentStartDate"]').value.split('-');
                    let endBooking = document.querySelector('input[name="rentEndDate"]').value.split('-');
                    let hourStartBooking = document.querySelector('select[name="rentStartTime"]') ? document.querySelector('select[name="rentStartTime"]').value : '00';
                    let hourEndBooking = document.querySelector('select[name="rentEndTime"]') ? document.querySelector('select[name="rentEndTime"]').value : '00';

                    let startBookingEvent = startBooking[2] + "-" + startBooking[1] + "-" + startBooking[0] + "T" + hourStartBooking + ":00";
                    let endBookingEvent = endBooking[2] + "-" + endBooking[1] + "-" + endBooking[0] + "T" + hourEndBooking + ":00";

                    if (document.querySelector('input[name="eventStartDate"]').value && document.querySelector('input[name="eventEndDate"]').value && document.querySelector('select[name="eventStartTime"]').value && document.querySelector('select[name="eventEndTime"]').value) {
                        let startEvent = document.querySelector('input[name="eventStartDate"]').value.split('-');
                        let endEvent = document.querySelector('input[name="eventEndDate"]').value.split('-');
                        let hourStartEvent = document.querySelector('select[name="eventStartTime"]').value;
                        let hourEndEvent = document.querySelector('select[name="eventEndTime"]').value;

                        let compareStartEvent = new Date(startEvent[2] + "-" + startEvent[1] + "-" + startEvent[0] + "T" + hourStartEvent + ":00");
                        let compareEndEvent = new Date(endEvent[2] + "-" + endEvent[1] + "-" + endEvent[0] + "T" + hourEndEvent + ":00");

                        let compareStartBooking = new Date(startBookingEvent);
                        let compareEndBooking = new Date(endBookingEvent);

                        // console.log(compareStartEvent, compareEndEvent);
                        // console.log('Compare start');
                        // console.log(compareStartEvent >= compareStartBooking);
                        // console.log('Compare end');
                        // console.log(compareEndEvent <= compareEndBooking);

                        if (compareStartEvent >= compareStartBooking && compareEndEvent <= compareEndBooking && compareStartEvent <= compareEndEvent && compareStartBooking <= compareEndBooking) {
                            createSelectEvent(startBookingEvent, endBookingEvent, true);

                            if (compareEndBooking <= compareEndEvent) {
                                if (item.name === 'eventEndDate') {
                                    document.querySelector('input[name="rentEndDate"]').value = document.querySelector('input[name="eventEndDate"]').value;
                                } else if (item.name === 'rentEndDate') {
                                    document.querySelector('input[name="eventEndDate"]').value = document.querySelector('input[name="rentEndDate"]').value;
                                }
                            } else if (compareStartBooking >= compareStartEvent) {
                                if (item.name === 'eventStartDate') {
                                    document.querySelector('input[name="rentStartDate"]').value = document.querySelector('input[name="eventStartDate"]').value;
                                } else if (item.name === 'rentStartDate') {
                                    document.querySelector('input[name="eventStartDate"]').value = document.querySelector('input[name="rentStartDate"]').value;
                                }
                            }
                        } else {
                            alert("Vous ne pouvez pas sélectionner une date de manifestation avec ces horaires");
                            document.querySelector('input[name="eventStartDate"]').value = document.querySelector('input[name="rentStartDate"]').value;
                            if (inputCalendars["eventStartDate"]) {
                                inputCalendars["eventStartDate"].setDate(document.querySelector('input[name="rentStartDate"]').value);
                            }
                            document.querySelector('input[name="eventEndDate"]').value = document.querySelector('input[name="rentEndDate"]').value;
                            if (inputCalendars["eventEndDate"]) {
                                inputCalendars["eventEndDate"].setDate(document.querySelector('input[name="rentEndDate"]').value);
                            }
                            document.querySelector('select[name="eventStartTime"]').value = document.querySelector('select[name="rentStartTime"]').value;
                            document.querySelector('select[name="eventEndTime"]').value = document.querySelector('select[name="rentEndTime"]').value;

                            if (compareStartBooking >= compareEndBooking || compareStartEvent >= compareEndEvent) {
                                document.querySelector('select[name="eventEndTime"]').value = document.querySelector('select[name="rentStartTime"]').value;
                                document.querySelector('select[name="rentEndTime"]').value = document.querySelector('select[name="rentStartTime"]').value;
                            }

                            let startBooking = document.querySelector('input[name="rentStartDate"]').value.split('-');
                            let endBooking = document.querySelector('input[name="rentEndDate"]').value.split('-');
                            let hourStartBooking = document.querySelector('select[name="rentStartTime"]') ? document.querySelector('select[name="rentStartTime"]').value : '00';
                            let hourEndBooking = document.querySelector('select[name="rentEndTime"]') ? document.querySelector('select[name="rentEndTime"]').value : '00';
                            let startBookingEvent = startBooking[2] + "-" + startBooking[1] + "-" + startBooking[0] + "T" + hourStartBooking + ":00";
                            let endBookingEvent = endBooking[2] + "-" + endBooking[1] + "-" + endBooking[0] + "T" + hourEndBooking + ":00";
                            createSelectEvent(startBookingEvent, endBookingEvent, true);
                        }

                    } else {
                        createSelectEvent(startBookingEvent, endBookingEvent, true);
                    }
                // }
            })
        })
    }

    /*
    * Logic change
    */

    if (document.querySelectorAll('#fullCalendar').length > 0) {
        [document.querySelector('input[name="eventStartDate"]'), document.querySelector('[name="eventStartTime"]'), document.querySelector('input[name="eventEndDate"]'), document.querySelector('[name="eventEndTime"]'), document.querySelector('input[name="rentStartDate"]'), document.querySelector('[name="rentStartTime"]'), document.querySelector('input[name="rentEndDate"]'), document.querySelector('[name="rentEndTime"]')].forEach(item => {
            item.addEventListener("change", event => {
                // if (document.querySelector('input[name="rentStartDate"]').value && document.querySelector('input[name="rentEndDate"]').value && document.querySelector('select[name="rentStartTime"]').value && document.querySelector('select[name="rentEndTime"]').value) {
                    if (item.name === 'eventStartDate' || item.name === 'rentStartDate') {
                        let minDateToChange = inputCalendars[item.name].selectedDates[0];
                        inputCalendars["eventStartDate"].setDate(minDateToChange);
                        inputCalendars["rentStartDate"].setDate(minDateToChange);

                        if (inputCalendars["eventEndDate"].selectedDates[0]) {
                            inputCalendars["eventEndDate"].set('minDate', minDateToChange);
                        } else {
                            inputCalendars["eventEndDate"].setDate(minDateToChange);
                            inputCalendars["eventEndDate"].set('minDate', minDateToChange);
                            document.querySelector('select[name="eventStartTime"]').value = "00:00";
                            document.querySelector('select[name="eventEndTime"]').value = "23:00";
                        }

                        if (inputCalendars["rentEndDate"].selectedDates[0]) {
                            inputCalendars["rentEndDate"].set('minDate', minDateToChange);   
                        } else {
                            inputCalendars["rentEndDate"].setDate(minDateToChange);
                            inputCalendars["rentEndDate"].set('minDate', minDateToChange);
                            document.querySelector('select[name="rentStartTime"]').value = "00:00";
                            document.querySelector('select[name="rentEndTime"]').value = "23:00";
                        }
                    }

                    if (item.name === 'eventEndDate' || item.name === 'rentEndDate') {
                        let dateToChange = inputCalendars[item.name].selectedDates[0];
                        
                        if (item.name === 'eventEndDate') {
                            inputCalendars["rentEndDate"].setDate(dateToChange);
                        } else if (item.name === 'rentEndDate') {
                            inputCalendars["eventEndDate"].setDate(dateToChange);
                        }
                    }

                    let startBooking = document.querySelector('input[name="rentStartDate"]').value.split('-');
                    let endBooking = document.querySelector('input[name="rentEndDate"]').value.split('-');
                    let hourStartBooking = document.querySelector('select[name="rentStartTime"]') ? document.querySelector('select[name="rentStartTime"]').value : '00';
                    let hourEndBooking = document.querySelector('select[name="rentEndTime"]') ? document.querySelector('select[name="rentEndTime"]').value : '00';

                    let startBookingEvent = startBooking[2] + "-" + startBooking[1] + "-" + startBooking[0] + "T" + hourStartBooking + ":00";
                    let endBookingEvent = endBooking[2] + "-" + endBooking[1] + "-" + endBooking[0] + "T" + hourEndBooking + ":00";

                    if (document.querySelector('input[name="eventStartDate"]').value && document.querySelector('input[name="eventEndDate"]').value && document.querySelector('select[name="eventStartTime"]').value && document.querySelector('select[name="eventEndTime"]').value) {
                        let startEvent = document.querySelector('input[name="eventStartDate"]').value.split('-');
                        let endEvent = document.querySelector('input[name="eventEndDate"]').value.split('-');
                        let hourStartEvent = document.querySelector('select[name="eventStartTime"]').value;
                        let hourEndEvent = document.querySelector('select[name="eventEndTime"]').value;

                        let compareStartEvent = new Date(startEvent[2] + "-" + startEvent[1] + "-" + startEvent[0] + "T" + hourStartEvent + ":00");
                        let compareEndEvent = new Date(endEvent[2] + "-" + endEvent[1] + "-" + endEvent[0] + "T" + hourEndEvent + ":00");

                        let compareStartBooking = new Date(startBookingEvent);
                        let compareEndBooking = new Date(endBookingEvent);

                        // console.log(compareStartEvent, compareEndEvent);
                        // console.log('Compare start');
                        // console.log(compareStartEvent >= compareStartBooking);
                        // console.log('Compare end');
                        // console.log(compareEndEvent <= compareEndBooking);

                        if (compareStartEvent >= compareStartBooking && compareEndEvent <= compareEndBooking && compareStartEvent <= compareEndEvent && compareStartBooking <= compareEndBooking) {
                            // createSelectEvent(startBookingEvent, endBookingEvent, true);

                            if (compareEndBooking <= compareEndEvent) {
                                if (item.name === 'eventEndDate') {
                                    document.querySelector('input[name="rentEndDate"]').value = document.querySelector('input[name="eventEndDate"]').value;
                                } else if (item.name === 'rentEndDate') {
                                    document.querySelector('input[name="eventEndDate"]').value = document.querySelector('input[name="rentEndDate"]').value;
                                }
                            } else if (compareStartBooking >= compareStartEvent) {
                                if (item.name === 'eventStartDate') {
                                    document.querySelector('input[name="rentStartDate"]').value = document.querySelector('input[name="eventStartDate"]').value;
                                } else if (item.name === 'rentStartDate') {
                                    document.querySelector('input[name="eventStartDate"]').value = document.querySelector('input[name="rentStartDate"]').value;
                                }
                            }
                        } else {
                            alert("Vous ne pouvez pas sélectionner une date de manifestation avec ces horaires");
                            document.querySelector('input[name="eventStartDate"]').value = document.querySelector('input[name="rentStartDate"]').value;
                            if (inputCalendars["eventStartDate"]) {
                                inputCalendars["eventStartDate"].setDate(document.querySelector('input[name="rentStartDate"]').value);
                            }
                            document.querySelector('input[name="eventEndDate"]').value = document.querySelector('input[name="rentEndDate"]').value;
                            if (inputCalendars["eventEndDate"]) {
                                inputCalendars["eventEndDate"].setDate(document.querySelector('input[name="rentEndDate"]').value);
                            }
                            document.querySelector('select[name="eventStartTime"]').value = document.querySelector('select[name="rentStartTime"]').value;
                            document.querySelector('select[name="eventEndTime"]').value = document.querySelector('select[name="rentEndTime"]').value;

                            if (compareStartBooking >= compareEndBooking || compareStartEvent >= compareEndEvent) {
                                document.querySelector('select[name="eventEndTime"]').value = document.querySelector('select[name="rentStartTime"]').value;
                                document.querySelector('select[name="rentEndTime"]').value = document.querySelector('select[name="rentStartTime"]').value;
                            }

                            let startBooking = document.querySelector('input[name="rentStartDate"]').value.split('-');
                            let endBooking = document.querySelector('input[name="rentEndDate"]').value.split('-');
                            let hourStartBooking = document.querySelector('select[name="rentStartTime"]') ? document.querySelector('select[name="rentStartTime"]').value : '00';
                            let hourEndBooking = document.querySelector('select[name="rentEndTime"]') ? document.querySelector('select[name="rentEndTime"]').value : '00';
                            let startBookingEvent = startBooking[2] + "-" + startBooking[1] + "-" + startBooking[0] + "T" + hourStartBooking + ":00";
                            let endBookingEvent = endBooking[2] + "-" + endBooking[1] + "-" + endBooking[0] + "T" + hourEndBooking + ":00";
                            // createSelectEvent(startBookingEvent, endBookingEvent, true);
                        }

                    } else {
                        // createSelectEvent(startBookingEvent, endBookingEvent, true);
                    }
                // }
            })
        })
    }

    /*
    * Logic change input
    */

    // if (document.querySelectorAll('.input-hour').length > 0 && document.querySelectorAll('.input-date').length > 0) {
    //     let allInputDates = [];
    //     let inputHourElements = document.querySelectorAll('.input-hour');
    //     let inputDateElements = document.querySelectorAll('.input-date');
    //     for (const inputDate of inputDateElements) {
    //         allInputDates.push(inputDate);
    //     }

    //     for (const inputHour of inputHourElements) {
    //         allInputDates.push(inputHour);
    //     }

    //     for (const inputDate of allInputDates) {
    //         inputDate.addEventListener('change', (e) => {
    //             // console.log('--------- START CHANGE ---------');
    //             let dateStartRentOriginal = document.querySelector('input[name="rentStartDate"]').value;
    //             let dateEndRentOriginal = document.querySelector('input[name="rentEndDate"]').value;
    //             let dateStartEventOriginal = document.querySelector('input[name="eventStartDate"]').value;
    //             let dateEndEventOriginal = document.querySelector('input[name="eventEndDate"]').value;

    //             let dateStartRent = document.querySelector('input[name="rentStartDate"]').value.split('-')[2] + '-' + document.querySelector('input[name="rentStartDate"]').value.split('-')[1] + '-' + document.querySelector('input[name="rentStartDate"]').value.split('-')[0];
    //             let dateEndRent = document.querySelector('input[name="rentEndDate"]').value.split('-')[2] + '-' + document.querySelector('input[name="rentEndDate"]').value.split('-')[1] + '-' + document.querySelector('input[name="rentEndDate"]').value.split('-')[0];
    //             let dateStartEvent = document.querySelector('input[name="eventStartDate"]').value.split('-')[2] + '-' + document.querySelector('input[name="eventStartDate"]').value.split('-')[1] + '-' + document.querySelector('input[name="eventStartDate"]').value.split('-')[0];
    //             let dateEndEvent = document.querySelector('input[name="eventEndDate"]').value.split('-')[2] + '-' + document.querySelector('input[name="eventEndDate"]').value.split('-')[1] + '-' + document.querySelector('input[name="eventEndDate"]').value.split('-')[0];

    //             let timeEndRent = document.querySelector('input[name="rentEndTime"]').value;
    //             let timeStartRent = document.querySelector('input[name="rentStartTime"]').value;
    //             let timeEndEvent = document.querySelector('input[name="eventEndTime"]').value;
    //             let timeStartEvent = document.querySelector('input[name="eventStartTime"]').value;

    //             let parsedEndDateRent = Date.parse(dateEndRent+'T'+timeEndRent+':00');
    //             let parsedStartDateRent = Date.parse(dateStartRent+'T'+timeStartRent+':00');
    //             let parsedEndDateEvent = Date.parse(dateEndEvent+'T'+timeEndEvent+':00');
    //             let parsedStartDateEvent = Date.parse(dateStartEvent+'T'+timeStartEvent+':00');

    //             // console.log('VALUE', parsedStartDateEvent, dateStartEvent+'T'+timeStartEvent+':00', parsedStartDateRent, dateStartRent+'T'+timeStartRent+':00', parsedStartDateEvent > parsedStartDateRent);

    //             if (parsedStartDateRent > parsedEndDateRent) {
    //                 // console.log('DATE START RENT > DATE END RENT');
    //                 if (inputDate.getAttribute('name') == 'rentStartTime') {
    //                     document.querySelector('input[name="rentEndTime"]').value = timeStartRent;
    //                     inputHours["rentEndTime"].setDate(timeStartRent);
    //                     document.querySelector('input[name="rentEndDate"]').value = dateStartRentOriginal;
    //                     inputCalendars["rentEndDate"].setDate(dateStartRentOriginal);
    //                 }
    //                 if (inputDate.getAttribute('name') == 'rentEndTime') {
    //                     document.querySelector('input[name="rentStartTime"]').value = timeEndRent;
    //                     inputHours["rentStartTime"].setDate(timeEndRent);
    //                     document.querySelector('input[name="rentStartDate"]').value = dateEndRentOriginal;
    //                     inputCalendars["rentStartDate"].setDate(dateEndRentOriginal);
    //                 }
    //                 if (inputDate.getAttribute('name') == 'rentStartDate' || inputDate.getAttribute('name') == 'rentEndDate') {
    //                     document.querySelector('input[name="rentEndTime"]').value = timeStartRent;
    //                     inputHours["rentEndTime"].setDate(timeStartRent);
    //                     document.querySelector('input[name="rentEndDate"]').value = dateStartRentOriginal;
    //                     inputCalendars["rentEndDate"].setDate(dateStartRentOriginal);

    //                     document.querySelector('input[name="eventEndTime"]').value = timeStartRent;
    //                     inputHours["eventEndTime"].setDate(timeStartRent);
    //                     document.querySelector('input[name="eventEndDate"]').value = dateStartRentOriginal;
    //                     inputCalendars["eventEndDate"].setDate(dateStartRentOriginal); 

    //                     document.querySelector('input[name="eventStartTime"]').value = timeStartRent;
    //                     inputHours["eventStartTime"].setDate(timeStartRent);
    //                     document.querySelector('input[name="eventStartDate"]').value = dateStartRentOriginal;
    //                     inputCalendars["eventStartDate"].setDate(dateStartRentOriginal);
    //                 }
    //             }
                
    //             if (parsedStartDateEvent > parsedEndDateEvent) {
    //                 // console.log('DATE START EVENT > DATE END EVENT');
    //                 if (inputDate.getAttribute('name') == 'eventStartTime') {
    //                     document.querySelector('input[name="eventEndTime"]').value = timeStartEvent;
    //                     inputHours["eventEndTime"].setDate(timeStartEvent);
    //                     document.querySelector('input[name="eventEndDate"]').value = dateStartEventOriginal;
    //                     inputCalendars["eventEndDate"].setDate(dateStartEventOriginal);   
    //                 }
    //                 if (inputDate.getAttribute('name') == 'eventEndTime') {
    //                     document.querySelector('input[name="eventStartTime"]').value = timeEndEvent;
    //                     inputHours["eventStartTime"].setDate(timeEndEvent);
    //                     document.querySelector('input[name="eventStartDate"]').value = dateEndEventOriginal;
    //                     inputCalendars["eventStartDate"].setDate(dateEndEventOriginal);
    //                 }
    //                 if (inputDate.getAttribute('name') == 'eventStartDate') {
    //                     document.querySelector('input[name="eventEndTime"]').value = timeStartEvent;
    //                     inputHours["eventEndTime"].setDate(timeStartEvent);
    //                     document.querySelector('input[name="eventEndDate"]').value = dateStartEventOriginal;
    //                     inputCalendars["eventEndDate"].setDate(dateStartEventOriginal);

    //                     document.querySelector('input[name="rentEndTime"]').value = timeStartEvent;
    //                     inputHours["rentEndTime"].setDate(timeStartEvent);
    //                     document.querySelector('input[name="rentEndDate"]').value = dateStartEventOriginal;
    //                     inputCalendars["rentEndDate"].setDate(dateStartEventOriginal);

    //                     document.querySelector('input[name="rentStartTime"]').value = timeStartEvent;
    //                     inputHours["rentStartTime"].setDate(timeStartEvent);
    //                     document.querySelector('input[name="rentStartDate"]').value = dateStartEventOriginal;
    //                     inputCalendars["rentStartDate"].setDate(dateStartEventOriginal);
    //                 }
    //             }

    //             if (parsedStartDateEvent < parsedStartDateRent) {
    //                 // console.log('DATE START EVENT < DATE START RENT');
    //                 if (inputDate.getAttribute('name') == 'eventStartTime') {
    //                     document.querySelector('input[name="rentStartTime"]').value = timeStartEvent;
    //                     inputHours["rentStartTime"].setDate(timeStartEvent);
    //                 }

    //                 if (inputDate.getAttribute('name') == 'rentStartTime') {
    //                     document.querySelector('input[name="eventStartTime"]').value = timeStartRent;
    //                     inputHours["eventStartTime"].setDate(timeStartRent);
    //                 }
    //             }

    //             if (parsedEndDateEvent > parsedEndDateRent) {
    //                 // console.log('DATE END EVENT > DATE END RENT');
    //                 if (inputDate.getAttribute('name') == 'eventEndTime' || inputDate.getAttribute('name') == 'eventEndDate') {
    //                     document.querySelector('input[name="rentEndTime"]').value = timeEndEvent;
    //                     inputHours["rentEndTime"].setDate(timeEndEvent);
    //                 }

    //                 if (inputDate.getAttribute('name') == 'rentEndTime' || inputDate.getAttribute('name') == 'rentEndDate') {
    //                     document.querySelector('input[name="eventEndTime"]').value = timeEndRent;
    //                     inputHours["eventEndTime"].setDate(timeEndRent);
    //                 }
    //             }

    //             if (parsedEndDateRent < parsedStartDateEvent) {
    //                 // console.log('DATE END RENT < DATE START EVENT');
    //                 if (inputDate.getAttribute('name') == 'rentEndTime') {
    //                     document.querySelector('input[name="eventStartTime"]').value = timeEndRent;
    //                     inputHours["eventStartTime"].setDate(timeEndRent);
    //                 }
    //             }

    //             if (parsedEndDateEvent < parsedStartDateRent) {
    //                 // console.log('DATE END EVENT < DATE START RENT');
    //                 if (inputDate.getAttribute('name') == 'rentStartTime') {
    //                     document.querySelector('input[name="eventEndTime"]').value = timeStartRent;
    //                     inputHours["eventEndTime"].setDate(timeStartRent);
    //                 }

    //                 if (inputDate.getAttribute('name') == 'eventEndTime') {
    //                     document.querySelector('input[name="rentStartTime"]').value = timeEndEvent;
    //                     inputHours["rentStartTime"].setDate(timeEndEvent);
    //                 }
    //             }

    //             // console.log('--------- END CHANGE ---------');
    //         });
    //     }
    // }

    /*
    * Linked to
    * */

    if (document.querySelectorAll("[data-linkedto]").length > 0) {
        let linkedtoFields = document.querySelectorAll("[data-linkedto]");
        for (const linkedtoField of linkedtoFields) {
            linkedtoField.addEventListener('change', function (e) {
                let fieldLinked = document.querySelector("[name='" + linkedtoField.dataset.linkedto + "']");
                let dateNow = new Date();
                fieldLinked.value = string_to_slug(linkedtoField.value) + '-' + dateNow.getYear() + dateNow.getMonth() + dateNow.getDate() + dateNow.getHours() + dateNow.getMinutes() + dateNow.getSeconds();
            });
        }
    }

    if (document.querySelectorAll("[data-linkedtoselect]").length > 0) {
        let linkedtoFields = document.querySelectorAll("[data-linkedtoselect]");
        for (const linkedtoField of linkedtoFields) {
            linkedtoField.addEventListener('change', function (e) {
                let fieldLinked = document.querySelector("[name='" + linkedtoField.dataset.linkedtoselect + "']");
                if (linkedtoField.value == "Autre") {
                    fieldLinked.setAttribute('required', 'required');
                } else {
                    fieldLinked.removeAttribute('required');
                }
            });
        }
    }

    if (document.querySelectorAll("[data-linkedtocheckbox]").length > 0) {
        let linkedtoFields = document.querySelectorAll("[data-linkedtocheckbox]");
        for (const linkedtoField of linkedtoFields) {
            linkedtoField.addEventListener('change', function (e) {
                if (linkedtoField.dataset.linkedtocheckbox.includes(',')) {
                    let fieldsLinked = linkedtoField.dataset.linkedtocheckbox.split(',');
                    for (const fieldLinked of fieldsLinked) {
                        let field = document.querySelector("[name='" + fieldLinked + "']");
                        if (linkedtoField.checked) {
                            field.setAttribute('required', 'required');
                            field.removeAttribute('disabled');
                        } else {
                            field.removeAttribute('required');
                            field.setAttribute('disabled', 'disabled');
                            field.checked = false;
                        }
                    }
                } else {
                    let fieldLinked = document.querySelector("[name='" + linkedtoField.dataset.linkedtocheckbox + "']");
                    if (linkedtoField.value == "Autre" && linkedtoField.checked) {
                        fieldLinked.setAttribute('required', 'required');
                    } else {
                        fieldLinked.removeAttribute('required');
                    }
                }
            });
        }
    }

    if (document.querySelectorAll("[data-reverselink]").length > 0) {
        let linkedtoFields = document.querySelectorAll("[data-reverselink]");
        for (const linkedtoField of linkedtoFields) {
            linkedtoField.addEventListener('change', function (e) {
                let fieldLinked = document.querySelector("[name='" + linkedtoField.dataset.reverselink + "']");
                if (linkedtoField.checked) {
                    fieldLinked.removeAttribute('required');
                } else {
                    fieldLinked.setAttribute('required', 'required');
                }
            });
        }
    }

    /*
    * Input files
    * */

    if (document.querySelectorAll('.inputfile').length > 0) {
        let inputs = document.querySelectorAll('.inputfile');
        Array.prototype.forEach.call(inputs, function (input) {
            let label = input.nextElementSibling,
                labelVal = label.innerHTML;

            input.addEventListener('change', function (e) {
                let fileName = '';
                if (this.files && this.files.length > 1) {
                    fileName = (this.getAttribute('data-multiple-caption') || '').replace('--count--', this.files.length);
                } else {
                    fileName = e.target.value.split("\\").pop();
                }

                if (fileName) {
                    label.querySelector('span').innerHTML = fileName;
                } else {
                    label.innerHTML = labelVal;
                }
            });
        });
    }

    /*
    * Auto Fill
    */

    if (document.querySelectorAll('.auto-fill').length > 0) {
        let autofills = document.querySelectorAll('.auto-fill');
        const arrayAssociationsFields = {
            "rentStartDate": "eventStartDate", 
            "rentStartTime": "eventStartTime", 
            "rentEndDate": "eventEndDate", 
            "rentEndTime": "eventEndTime"
        };
        for (const autofill of autofills) {
            autofill.addEventListener('change', function (event) {
                document.querySelector('input[name="' + arrayAssociationsFields[autofill.getAttribute('name')] + '"]').value = autofill.value;
                if (autofill.getAttribute('name') == 'rentStartDate') {
                    inputCalendars["rentEndDate"].set('minDate', autofill.value);
                } else if (autofill.getAttribute('name') == 'rentEndDate') {
                    inputCalendars["rentStartDate"].set('maxDate', autofill.value);
                }
            })
        }
    }

    /*
    * Concession de boisson
    */

    // if (document.querySelectorAll('input[name="custom.beverageConcession"]').length > 0) {
    //     let concession = document.querySelector('input[name="custom.beverageConcession"]');
    //     concession.addEventListener('change', function (event) {
    //         if (concession.checked) {
    //             document.querySelector('input[name="beverageCopy"]').value = document.querySelector('input[name="beverageCopy"]').dataset.email;
    //         } else {
    //             document.querySelector('input[name="beverageCopy"]').value = '';
    //         }
    //     })
    // }


    // Example starter JavaScript for disabling form submissions if there are invalid fields
    (function () {
        'use strict'

        // Fetch all the forms we want to apply custom Bootstrap validation styles to
        var forms = document.querySelectorAll('.needs-validation');

        // Loop over them and prevent submission
        Array.prototype.slice.call(forms)
            .forEach(function (form) {
                form.addEventListener('submit', function (event) {
                    if (document.querySelectorAll('#fullCalendar').length > 0) {
                        if (document.querySelector('input[name="rentStartDate"]').value && document.querySelector('input[name="rentEndDate"]').value && document.querySelector('select[name="rentStartTime"]').value && document.querySelector('select[name="rentEndTime"]').value) {
                            let eventDate = {
                                start: document.querySelector('input[name="rentStartDate"]').value + "T" + document.querySelector('select[name="rentStartTime"]').value + ":00",
                                end: document.querySelector('input[name="rentEndDate"]').value + "T" + document.querySelector('select[name="rentEndTime"]').value + ":00"
                            };

                            // console.log(eventDate);
                            // console.log(isOverlapping(eventDate));

                            if (isOverlapping(eventDate)) {
                                alert('Cette date est déja occupée');
                                event.preventDefault();
                                event.stopPropagation();
                                window.scrollTo(0, document.querySelector('label[for="rentStartDate"]').getBoundingClientRect().top + window.scrollY);
                            }
                        }
                    }

                    if (!form.checkValidity()) {
                        if (document.querySelectorAll('#fullCalendar').length > 0) {
                            alert('Il manque des champs requis');
                        }
                        event.preventDefault();
                        event.stopPropagation();
                        window.scrollTo(0, document.querySelector('#formContact').getBoundingClientRect().top + window.scrollY);
                    }

                    form.classList.add('was-validated');
                }, false)
            })
    })()
})
